import { useTranslation } from "react-i18next";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";

import { DataType } from "shared/types";

import Button from "features/components/Button";
import IconButton from "features/components/IconButton";

import {
  ColumnCellRenderProps,
  SmartGroupColumnDefinition,
  SmartGroupColumnId,
} from "./types";

const ActionsCell = ({ params, row, context }: ColumnCellRenderProps) => {
  const { t } = useTranslation();
  const { onOpenDetails } = context;
  const showIconOnly = (params.colDef.computedWidth || 0) <= 116;

  return (
    <div className="flex items-center h-full w-full justify-end">
      {showIconOnly ? (
        <IconButton
          testId="smart-group-table-investigate-row-button"
          size="small"
          color="primary"
          onClick={(event) => {
            event.stopPropagation();
            onOpenDetails(row.groupID);
          }}
        >
          <ManageSearchOutlinedIcon />
        </IconButton>
      ) : (
        <Button
          testId="smart-group-table-investigate-row-button"
          size="small"
          color="primary"
          onClick={(event) => {
            event.stopPropagation();
            onOpenDetails(row.groupID);
          }}
        >
          {t("schema:dashboard.investigate")}
        </Button>
      )}
    </div>
  );
};

export const actionsColumn: SmartGroupColumnDefinition = {
  id: SmartGroupColumnId.ACTIONS,

  getSchema: () => ({
    accessor: "actions",
    label: "",
    dataType: DataType.JSX,
    flex: 1,
    minWidth: 50,
  }),

  renderHeader: () => null,

  renderCell: (props: ColumnCellRenderProps) => <ActionsCell {...props} />,
};
